<template>
  <div class="component-textarea" :class="computedClass">
    <div class="textarea-render" :style="{ height: height }">
      <textarea
        class="component-inner-textarea w-normal"
        :value="value"
        @input="handleInput"
        :placeholder="placeholder"
        :disabled="disabled"
        @blur="handleBlur"
      ></textarea>
    </div>
    <div class="info-render">
      <div class="err-msg" v-if="showMsg">{{ msg }}</div>
      <div class="count-info w-normal" v-if="counter">
        {{ wordsLength }}<template v-if="maxCount">/{{ maxCount }}</template>
      </div>
    </div>
    <slot></slot>
  </div>
</template>
<script>
import { wordLength } from '../../../utils/string';
/**
 * 文本框组件
 * @module Textarea
 */
export default {
  name: 'Textarea',
  /**
   * @prop {String} className 组件class名
   * @prop {String} placeholder 水印文本
   * @prop {Boolean} error 是否错误状态 默认false
   * @prop {Boolean} counter 是否展示计数器 默认true
   * @prop {Number} maxCount 计数器最大值展示 默认100
   * @prop {String} value 内容
   * @prop {String} msg 错误信息
   * @prop {Boolean} showMsg 是否展示错误信息 默认true
   * @prop {Boolean} disabled 是否为禁用状态 默认false
   */
  props: {
    height: {
      type: String,
      default: '120px'
    },
    className: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '输入框'
    },
    error: {
      type: Boolean,
      default: false
    },
    counter: {
      type: Boolean,
      default: true
    },
    counterReg: {
      type: RegExp
    },
    maxCount: {
      type: Number,
      default: 100
    },
    value: {
      type: String,
      default: ''
    },
    msg: {
      type: String,
      default: ''
    },
    showMsg: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  /**
   * @prop {Object} computedClass 组件class
   * @prop {Number} wordsLength 单词计数
   */
  computed: {
    computedClass() {
      let ret = {};
      ret[this.className] = true;
      ret['error'] = this.error;
      ret['disabled'] = this.disabled;
      return ret;
    },
    wordsLength() {
      let ret = 0;
      if (this.counter) {
        if (this.counterReg) {
          ret = this.value.match(this.counterReg)?.length || 0;
        } else {
          ret = wordLength(this.value);
        }
      }
      return ret;
    }
  },
  methods: {
    /**
     * @event input 输入事件
     * @param {String} value 输入字符串
     */
    /**
     * @description 输入事件
     * @function handleInput
     * @param {Object} e 事件对象
     */
    handleInput: function(e) {
      let value = e.target.value;
      this.$emit('input', value);
    },
    /**
     *  失去焦点
     */
    handleBlur() {
      this.$emit('blur');
    }
  }
};
</script>
<style lang="less" src="./index.less" scoped></style>
